'use es6';
/*
 * Copied over from legacy template_builder.
 */

export const CSS = `
/* @import url('http://example.com/example_style.css'); */

/***********************************************/
/* CSS @imports must be at the top of the file */
/* Add them above this section                 */
/***********************************************/

/*****************************************/
/* Start your style declarations here    */
/*****************************************/
`.trim();
export const HTML = `
<!doctype html>
<html>
    <head>
        <meta charset="utf-8">
        <title>{{ content.html_title }}</title>
        <meta name="description" content="{{ content.meta_description }}">
        {{ standard_header_includes }}
    </head>
    <body>
        {{ standard_footer_includes }}
    </body>
</html>
`;
export const HTML_EMAIL = `
<!doctype html>
<html>
    <head>
        <title>{% if content.html_title and content.html_title != '' %}{{ content.html_title }}{% else %}{{ content.body.subject }}{% endif %}</title>
        {% if content.meta_description %}<meta name="description" content="{{ content.meta_description }}"/>{% endif %}

        <style type="text/css" id="hs-inline-css">
            /*<![CDATA[*/
            /* everything in this style tag will be inlined onto matching elements */
            .sample-rule {

            }
            /*]]>*/
        </style>
    </head>
    <body>
        <!-- Preview text (text which appears right after subject in certain email clients) -->
        <div id="preview_text" style="display:none!important">{% text "preview_text" label="Preview Text <span class=help-text>This will be used as the preview text that displays in some email clients</span>", value="", no_wrapper=True %}</div>

        <!-- View as webpage link -->
        {% if content.create_page %}
            <div>
                Not rendering correctly? View this email as a web page <a class="hubspot-mergetag" data-viewaswebpage="true" href="{{ view_as_page_url }}">here</a>.
            </div>
        {% endif %}


        <!-- Insert body here -->


        <!-- Office location information and unsubscribe links -->
        <p id="footer">
            {{ site_settings.company_name }}&nbsp;
            {{ site_settings.company_street_address_1 }}&nbsp;
            {{ site_settings.company_street_address_2 }}&nbsp;
            {{ site_settings.company_city }}&nbsp;
            {{ site_settings.company_state }}&nbsp;
            {{ site_settings.company_zip }}&nbsp;
            {{ site_settings.company_country }}&nbsp;
            <br/>
            You received this email because you are subscribed to {{ subscription_name }} from {{ site_settings.company_name }}.
            <br/>
            Update your <a class="hubspot-mergetag" data-unsubscribe="true" href="{{ unsubscribe_link }}">email preferences</a> to choose the types of emails you receive.
            <br/>
            <a class="hubspot-mergetag" data-unsubscribe="true" href="{{ unsubscribe_link_all }}">Unsubscribe from all future emails</a>
        </p>
    </body>
</html>
`.trim();